import { Injectable } from '@angular/core'
import { UnespCoreMessageService } from '@unesp/core'
import { EMPTY, catchError as catchErrorRxJS, Observable, OperatorFunction } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService {
  constructor(private unespCoreMessageService: UnespCoreMessageService) {}

  catchError<T>(): OperatorFunction<T, T> {
    return catchErrorRxJS<T, Observable<T>>(err => {
      if (err.status == 404) {
        this.unespCoreMessageService.showMessageError('O recurso solicitado não está disponível')
      } else {
        if (err.error instanceof Blob) {
          new Response(err.error).text().then(data => {
            const content = JSON.parse(data)
            this.unespCoreMessageService.showMessageError(content.message)
          })
        } else {
          err.error.message
            ? this.unespCoreMessageService.showMessageError(err.error.message)
            : this.unespCoreMessageService.showMessageError(err.message)
        }
      }
      return EMPTY
    })
  }
}
